<template>
    <div class="popup" v-cloak v-if="isShow">
        <div class="content" id="downloadThread">
            <div class="title">
                <span>{{$t('language.popup.downloadThreadPopup.title')}}</span>
                <div class="icon white-close dialog-close" @click="closePage()"></div>
            </div>
            <div class="download-thread-content">
                <div class="download-thread-title">{{$t('language.popup.downloadThreadPopup.tips')}}</div>
                <div><input v-model="name" id="zipName" :placeholder="defaultName" onfocus="this.placeholder=''"  :onblur="'this.placeholder=\''+defaultName+'\''" maxlength="255"></div>
                <div class="download-thread-options">
                    <div style="margin-bottom:8px;">
                        <div class="icon-util" :class="isSave?'check-small':'nocheck-small-blue'" @click="isSave=!isSave"></div>
                        <div>{{$t('language.popup.downloadThreadPopup.option1')}}</div>
                    </div>
                    <div style="position: relative;margin-bottom:8px;">
                        <div class="icon-util" :class="isCoversation?'check-small':'nocheck-small-blue'" @click="isCoversation=!isCoversation"></div>
                        <div>{{$t('language.popup.downloadThreadPopup.option2')}}
                            <div class="icon-util question-mark">
                                <div class="plan-questionTxt">{{$t('language.popup.downloadThreadPopup.option2Tips')}}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="icon-util" :class="isSaveLast?'check-small':'nocheck-small-blue'" @click="isSaveLast=!isSaveLast"></div>
                        <div>{{$t('language.popup.downloadThreadPopup.option3')}}</div>
                    </div>
                </div>
            </div>
            <div class="download-thread-footer">
                <button v-if="!loading" @click="download()"><span>{{$t('language.common.ok')}}</span></button>
                <button v-if="loading" ><span v-loading='loading'></span></button>
            </div>
        </div>
    </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            selectItems: [],//下载列表
            isShow: false,
            loading: false,
            name: "",//下载包名
            defaultName: "",
            isSave: true,
            isCoversation: true,
            isSaveLast: false,
        }
    },
    methods: {
        //初始化默认信息
        init(selectItems) {
            this.selectItems = selectItems;
            if(this.selectItems.length>1){
                this.name = this.$t('language.popup.downloadThreadPopup.defaultName',{"num":this.selectItems.length,"date":this.getNowDataForName()});
            }else{
                if(this.$route.query.cloudType=='outlook'){
                    this.name = this.getDataForNameOnlyOne(this.selectItems[0].date) + " [" + this.emailsFilter(this.selectItems[0].from) + "] " + this.selectItems[0].subject;
                }else{
                    this.name = this.$t('language.popup.downloadThreadPopup.defaultNameOne',{"date":this.getNowDataForName()});
                }
            }
            // this.name = "";
            this.isSave = true;
            this.isCoversation = true;
            this.isSaveLast = false;
            this.isShow = true;
            this.$nextTick(() => {  
                $("#zipName").focus();
                $("#zipName").select();
            });
        },
        //关闭弹窗
        closePage() {
            this.isShow = false;
        },
        download() {
            //超下载数限制
            if(this.selectItems.length>200){
                this.$toast({
                    text: this.$t('language.cloudExploer.uploadError'),
                    type: 'fail',
                    idValue: "rightBo"
                });
                return;
            }
            //使用默认名
            if(this.name.length<1){
                this.name = this.defaultName;
            }else{
                this.name = this.name.trim();
            }
            //超长名限制
            if(this.name.length>255){
                this.$toast({
                    text: this.$t('language.cloudExploer.uploadError'),
                    type: 'fail',
                    idValue: "rightBo"
                });
                return;
            }

            //特殊字符限制
            var pattern = /[/|:*?"<>]/gi
            if(pattern.test(this.name)){
                this.$toast({
                    text: this.$t('language.cloudExploer.specialCharError'),
                    type: 'fail',
                    idValue: "rightBo"
                });
                return;
            }
            let downloadData = [];
            //处理数据
            this.selectItems.forEach(item => {
                let thread = {
                    id: item.id,
                    ud: commonUtils.getUser().id,
                    dd: this.$parent.$route.query.tokenId,
                    zipName: this.name,
                    attachment: this.isSave,
                    conversationQuoted: this.isCoversation,
                    onlyLastMail: this.isSaveLast
                };
                thread.threadId = item.threadId;
                thread.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;//传时区
                downloadData.push(thread);
            });
            let that = this;
            this.Utils.doCloudEmailRequest("download.createSession", downloadData).then(result => {
                if (result.status == 200) {
                    var $eleForm = commonUtils.createDownloadFormEmail(result.download_id);
                    $eleForm.submit();
                    that.closePage();
                } else if (result.status == 400 && result.reason == 'notEnoughTimes'){
                    //弹出付费弹窗
                    that.$parent.$refs.upgradeDialog.upgradeShow = true;
                    that.$parent.$refs.upgradeDialog.reset();
                    that.$parent.$refs.upgradeDialog.emailShow = true;
                    that.closePage()
                    return false;
                } else {
                    that.$toast({
                        text: that.$t('language.cloudExploer.uploadError'),
                        type: 'fail',
                        idValue: "rightBo"
                    });
                }
            });
        },
        //处理默认名日期信息
        getNowDataForName() {
            let date = new Date();
            let yearValue = date.getFullYear();
            let monthValue = date.getMonth() + 1;
            let dayValue = date.getDate();
            monthValue = monthValue < 10 ? ('0' + monthValue) : monthValue;
            dayValue = dayValue < 10 ? ('0' + dayValue) : dayValue;
            return monthValue + '-' + dayValue + '-' + yearValue;
        },
        //处理默认名日期信息
        getDataForNameOnlyOne(dateTime) {
            let date = new Date(dateTime*1);
            let yearValue = date.getFullYear();
            let monthValue = date.getMonth() + 1;
            let dayValue = date.getDate();
            let hourValue = date.getHours();
            let minValue = date.getMinutes();
            monthValue = monthValue < 10 ? ('0' + monthValue) : monthValue;
            dayValue = dayValue < 10 ? ('0' + dayValue) : dayValue;
            return yearValue + '-' + monthValue + '-' + dayValue + ' ' + hourValue + minValue;
        },
        //outlook处理from，获取邮箱名
        emailsFilter(value) {
            if (!value) return '';
            let filterIndex = value.lastIndexOf(' <');
            if(filterIndex>0){
                return value.substring(filterIndex+2,value.length-1);
            }else {
                return '';
            }
        }
    }
}
</script>

<style scoped>
#downloadThread {
    width: 500px;
    /*no*/
    height: 300px;
    /*no*/
    font-family: Arial;
}

.download-thread-content{
    padding: 20px;/*no*/
    font-size: 14px;/*no*/
}

.download-thread-title {
    font-weight: bold;
}

.download-thread-content input {
    border-radius: 6px;/*no*/
    height: 32px;/*no*/
}

.download-thread-options {
    margin-top: 24px;/*no*/
    line-height: 20px;/*no*/
    font-weight: 400;
    color: #000000;
}

.download-thread-options .check-small,
.download-thread-options .nocheck-small-blue {
    margin-top: 3px;/*no*/
    margin-right: 10px;/*no*/
    float: left;
    cursor: pointer;
}

.download-thread-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;/*no*/
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
    text-align: right;
}

.download-thread-footer button {
    padding: 0 20px !important;/*no*/
    min-width: 110px;/*no*/
}

#downloadThread .el-loading-spinner .path {
    stroke: #fff !important;
}
#downloadThread .el-loading-spinner {
    position: relative;
    top: 29px;
    /*no*/
    left: -10px;
    /*no*/
}
#downloadThread .el-loading-spinner i {
    color: #fff;
}
#downloadThread .el-loading-spinner {
    font-size: 15px;
    /*no*/
}

.question-mark{
    position: absolute;
}

.question-mark:hover .plan-questionTxt {
  display: block;
}

.plan-questionTxt {
  text-align: left;
  display: none;
  position: absolute;
  width: 280Px;/*no*/
  border: 1Px solid #5562b4;/*no*/
  border-radius: 3Px;/*no*/
  left: 10Px !important;/*no*/
  top: 18Px !important;/*no*/
  background: #fff;
  z-index: 3;
  font-size: 12Px;/*no*/
  box-sizing: border-box;
  padding: 5Px;/*no*/
  line-height: 20Px;/*no*/
  color: #333333;
}

#downloadThread input{
    color: #6F7886;
}

</style>


// WEBPACK FOOTER //
// src/components/popup/email_exploer_popups/download_thread_popup.vue